/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Case_Section_Liable_Vehicles_DescriptionInputs */

const en_case_section_liable_vehicles_description = /** @type {(inputs: Case_Section_Liable_Vehicles_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The third-party vehicles responsible for the damage.`)
};

const pt_br2_case_section_liable_vehicles_description = /** @type {(inputs: Case_Section_Liable_Vehicles_DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Os veículos de terceiros responsáveis pelo dano.`)
};

/**
* | output |
* | --- |
* | "The third-party vehicles responsible for the damage." |
*
* @param {Case_Section_Liable_Vehicles_DescriptionInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const case_section_liable_vehicles_description = /** @type {((inputs?: Case_Section_Liable_Vehicles_DescriptionInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Case_Section_Liable_Vehicles_DescriptionInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_case_section_liable_vehicles_description(inputs)
	return pt_br2_case_section_liable_vehicles_description(inputs)
});